/** Strings owned by `src/features/pilots/` — WP-04's `/pilots` list and
 * `/pilots/:pilotId` detail page. */
export const pilots = {
  page: {
    title: 'Pilots',
    lead: 'Pilots running at {{company}}.',
    noScope: 'Select a company to see its pilots.',
    listTitle: 'Pilots',
    empty: 'No pilots yet.',
  },
  status: {
    draft: 'Draft',
    baseline: 'Baseline',
    active: 'Active',
    interim_review: 'Interim review',
    final_review: 'Final review',
    completed: 'Completed',
    scaled: 'Scaled',
  },
  phases: {
    baseline: 'Baseline measurement',
    interim: 'Interim evaluation',
    final: 'Final evaluation',
  },
  kpis: {
    participationRate: 'Participation rate',
    activeUsers: 'Active users',
    dailyUsage: 'Daily usage',
    satisfaction: 'Employee satisfaction',
    avgVitality: 'Avg. vitality',
    aiCoachUsage: 'AI coach usage',
    challengeUsage: 'Challenge usage',
    rolloutReadiness: 'Rollout readiness',
  },
  form: {
    title: 'New pilot',
    name: 'Name',
    startDate: 'Start date',
    departments: 'Departments',
    submit: 'Create pilot',
  },
  detail: {
    title: 'Pilot',
    lead: 'Evaluation of the vitality pilot with KPIs, trends, conclusions and a substantiated rollout decision.',
    exportPdf: 'Export report (PDF)',
    hero: {
      badge: {
        success: 'Pilot succeeded',
        partial: 'Pilot in progress',
        atRisk: 'Attention required',
        pending: 'Pilot running',
      },
      goals: {
        success: 'All KPI targets met',
        partial: 'Some KPI targets met',
        atRisk: 'KPI targets not yet met',
        pending: 'Not enough data yet for an advice',
      },
      headlinePrefix: {
        success: 'The pilot proves that NOLATR Fit measurably improves vitality — advice:',
        partial: 'The pilot shows improvement — advice:',
        atRisk: 'The pilot does not yet show measurable improvement — advice:',
        pending: 'There is not yet enough data for an advice on',
      },
      headlineAdvice: {
        success: 'scale up to the whole organization.',
        partial: 'extend the pilot for more data.',
        atRisk: 'address this before scaling up.',
        pending: 'scaling up.',
      },
    },
    summary: {
      participation: 'Participation',
      dailyActive: 'Daily active',
      stress: 'Stress',
      sleep: 'Sleep',
      goal: 'goal {{value}}%',
      vsBaseline: 'vs. baseline',
      minutes: '{{value}} min',
    },
    aiSummaryTitle: 'AI summary',
    recommendationEmpty: 'No summary written yet.',
    kpisTitle: 'KPIs',
    chartTitle: 'Vitality & activity during the pilot',
    chartCurrent: 'Current',
    noData: 'No data yet.',
    participantCount: '{{count}} participants',
    evaluationsTitle: 'Conclusions & recommendations',
    conclusionsTitle: 'Conclusions',
    recommendationsListTitle: 'Recommendations',
    evaluationsEmpty: 'No evaluations recorded yet.',
    evaluationPhase: 'Phase',
    evaluationConclusions: 'Conclusions',
    evaluationRecommendations: 'Recommendations',
    decisionTitle: 'Decision',
    scaleRequiresCompleted:
      'Scaling up is only possible once the pilot has completed its final review.',
  },
  actions: {
    new: 'New pilot',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    addEvaluation: 'Add evaluation',
    extend: 'Extend',
    scale: 'Scale up',
  },
} as const;
